import { jsx } from "panel";
import { InputEl } from "common/components/input";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { SelectEl } from "common/components/select";
import { RadioButtonEl } from "common/components/radio-button";
import { ButtonEl } from "common/components/button";
import { Placement } from "common/components/tooltip/types";
import { ButtonTheme } from "common/components/button/constants";
import { Permission } from "common/report/constants";
export function template() {
  const { selectedDataResidency, timezones, selectedTimezone, selectedOrganizationId } = this.state;
  const orgData = this.attr(`orgs`);
  const isSetup = this.attr(`is-setup`);
  const isFyt = this.attr(`is-fyt`);
  return /* @__PURE__ */ jsx("div", {
    sel: ".create-project-field-container"
  }, /* @__PURE__ */ jsx(InputEl, {
    sel: ".project-name-input",
    attrs: {
      "field-id": `project-name`,
      label: `Project Name`,
      placeholder: `e.g. Production Analytics`,
      ...isFyt ? {
        "help-text": `You may change your project name in settings at any time.`
      } : {}
    },
    on: { input: (ev) => this.update({ projectName: ev.target.value }) },
    hook: { insert: ({ elm }) => requestAnimationFrame(() => elm.focus()) }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".data-residency-radio-group"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".label .mp-input-label"
  }, "Select Where To Store Your Data", /* @__PURE__ */ jsx("div", {
    sel: ".info"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` }
  }), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Bottom, "max-width": `300px` }
  }, "If you are a Mixpanel customer in the EU, you have the option to send your data to Mixpanel's EU data center. You do not lose any product capability if you choose to store your data in the EU."))), /* @__PURE__ */ jsx("div", {
    sel: ".radio-btn",
    on: { click: () => this.update({ selectedDataResidency: `US` }) }
  }, /* @__PURE__ */ jsx(RadioButtonEl, {
    attrs: { selected: selectedDataResidency === `US` }
  }, "\u{1F1FA}\u{1F1F8} United States")), /* @__PURE__ */ jsx("div", {
    sel: ".radio-btn",
    on: { click: () => this.update({ selectedDataResidency: `EU` }) }
  }, /* @__PURE__ */ jsx(RadioButtonEl, {
    attrs: { selected: selectedDataResidency === `EU` }
  }, "\u{1F1EA}\u{1F1FA} European Union"))), /* @__PURE__ */ jsx("div", {
    sel: ".timezones-dropdown-area"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-input-label"
  }, "Select Your Timezone"), /* @__PURE__ */ jsx(SelectEl, {
    sel: ".timezones-dropdown",
    attrs: {
      options: timezones.map((timezoneEntry) => timezoneEntry[1]),
      "label-transform": `uppercase`,
      tabindex: 0,
      "selected-option": selectedTimezone ? selectedTimezone[1] : ``,
      "force-visibility": true
    },
    on: {
      change: this.helpers.handleChangeSelectedTimezone
    }
  })), orgData && orgData.length > 1 && /* @__PURE__ */ jsx("div", {
    sel: ".select-org"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".select-org-label"
  }, "Select Organization"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-chrome-create-project-modal-radio-button-container"
  }, orgData.map((org) => {
    const disabled = !this.helpers.orgHasPerm(org, Permission.CreateProject);
    return !disabled && /* @__PURE__ */ jsx("div", {
      sel: ".radio-btn"
    }, /* @__PURE__ */ jsx(RadioButtonEl, {
      attrs: { selected: selectedOrganizationId === org.id, disabled },
      on: { click: () => !disabled && this.update({ selectedOrganizationId: org.id }) }
    }, org.name));
  }))), /* @__PURE__ */ jsx("div", {
    style: { textAlign: this.attr(`button-area-align`) || `right` }
  }, isSetup ? null : !isFyt && /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".skip-btn",
    attrs: {
      theme: ButtonTheme.Tertiary,
      role: `button`,
      tabindex: 0
    },
    on: { click: this.helpers.clickedCancel }
  }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".create-btn",
    attrs: {
      theme: ButtonTheme.Primary,
      role: `button`,
      tabindex: 0,
      disabled: this.helpers.isSubmitDisabled()
    },
    on: { click: !this.helpers.isSubmitDisabled() && this.helpers.createProject }
  }, "Create")));
}
